/** Picks v2 or v1 of Cancellation Reasons based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CancellationReasonPage   from './CancellationReasonPage';
import CancellationReasonPageV2 from './v2/CancellationReasonPageV2';

export default function CancellationReasonPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CancellationReasonPageV2 : CancellationReasonPage;
  return <Component {...props} />;
}
